/** @format */

import {Box} from '@mui/material';
import {styled} from '@mui/material/styles';

// Width at/under which the KPI and Расход blocks stack vertically instead of sitting side by side.
const STACK_BREAKPOINT = '@media (max-width:834px)';

// Two-column body in ONE bordered rounded box (Figma node 10284:125836/124678): KPI section
// (left) | center divider | Spend section (right). The divider is a real 1px flex child butting
// the columns flush (gap 0); each column gets its 16px breathing room from its own row padding.
// At ≤834px the columns stack vertically (divider turns horizontal).
export const MetricsRoot = styled(Box)(({theme}) => ({
  display: 'flex',
  alignItems: 'stretch',
  width: '100%',
  border: `1px solid ${theme.palette.semantic_dark?.surface.surface2}`,
  borderRadius: 8,
  overflow: 'hidden',
  [STACK_BREAKPOINT]: {
    flexDirection: 'column',
  },
}));

// Left column — KPI section. Grows to fill the available width; full width when stacked.
export const KpiColumn = styled(Box)(() => ({
  flex: '1 1 0',
  minWidth: 0,
  display: 'flex',
  flexDirection: 'column',
  [STACK_BREAKPOINT]: {
    flex: '0 0 auto',
    width: '100%',
  },
}));

// Center divider — 1px surface-2 (Figma node 10284:124678). Vertical between columns,
// horizontal between the stacked blocks at ≤834px.
export const CenterDivider = styled(Box)(({theme}) => ({
  flex: '0 0 auto',
  width: 1,
  alignSelf: 'stretch',
  backgroundColor: theme.palette.semantic_dark?.surface.surface2,
  [STACK_BREAKPOINT]: {
    width: '100%',
    height: 1,
    alignSelf: 'auto',
  },
}));

// Right column — Spend section. Sized to its content; full width when stacked.
export const SpendColumn = styled(Box)(() => ({
  flex: '1 1 0',
  minWidth: 0,
  display: 'flex',
  flexDirection: 'column',
  [STACK_BREAKPOINT]: {
    flex: '0 0 auto',
    width: '100%',
  },
}));
